import { useDarkMode } from "../../../../context/ThemeContext";

export default function AlertsSection() {
  const { isDarkMode } = useDarkMode();
  const themeClasses = {
    text: isDarkMode ? 'text-white' : 'text-gray-900',
    textSecondary: isDarkMode ? 'text-gray-400' : 'text-gray-600',
  };

  return (
    <div className="h-full flex flex-col items-center justify-center">
      <i className={`ri-alert-line text-6xl ${isDarkMode ? 'text-gray-600' : 'text-gray-400'} mb-4`}></i>
      <h2 className={`text-2xl font-bold ${themeClasses.text} mb-2`}>Gestión de Alertas</h2>
      <p className={`${themeClasses.textSecondary} text-center max-w-md`}>
        Esta sección está en desarrollo. Aquí podrás configurar y administrar todas las alertas del sistema.
      </p>
    </div>
  );
}
